/**
 * @note: should we namespace filters as well?
 * @description: a very simple general purpose filter to mask a value with a string
 * @example secretMessage | mask:features.someFeatureFlag:"--"'
 * @example secretNumbers | mask:$ctrl.canViewSpend():"$$"'
 * @param: {Generic} val - original value that may be masked
 * @param: {Boolean} willMaskValue: {boolean} will determine if the mask should be applied
 * @param: {String} mask: {string} any string value that will replace the original value
 * @return {Generic | String}
 */
export default function MaskFilter() {
  return <T>(val: T, willMaskValue: boolean, mask: string): string | T => {
    if (willMaskValue) {
      return mask;
    } else {
      return val;
    }
  };
}
